module.exports = __webpack_public_path__ + "static/media/SQLServer.0a894299.png";